import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { LegalLinks } from "./LegalLinks";
import "./LegalPage.css";

interface LegalPageProps {
  title: string;
  /** Shown as "Last updated: …". Leave empty until the text is final. */
  lastUpdated?: string;
  children: ReactNode;
}

/**
 * Shared chrome for the public legal pages. Rendered outside ContextGuard
 * (see App.tsx), so it must not depend on auth or org context.
 */
export function LegalPage({ title, lastUpdated, children }: LegalPageProps) {
  return (
    <div className="legal-page">
      <header className="legal-page__header">
        <Link to="/" className="legal-page__brand">Haven</Link>
      </header>
      <main className="legal-page__main">
        <article className="legal-page__article">
          <h1>{title}</h1>
          {lastUpdated && <p className="legal-page__updated">Last updated: {lastUpdated}</p>}
          {children}
        </article>
      </main>
      <footer className="legal-page__footer">
        <LegalLinks />
      </footer>
    </div>
  );
}
